<mat-form-field
    [floatLabel]="hasFloatingLabel ? 'always' : 'auto'"
    class="w-full"
    [color]="color"
    [arcErrorTooltip]="internalControl"
    [subscriptSizing]="hasFixedSubscript ? 'fixed' : 'dynamic'">
    @if (!!label) {
        <mat-label>{{ isLabelTranslated ? label : (label | transloco) }}</mat-label>
    }
    <input
        matInput
        [formControl]="internalControl"
        (blur)="onBlur()"
        type="text"
        [placeholder]="isPlaceholderTranslated ? placeholder : (placeholder | transloco)"
        [matAutocomplete]="autocomplete"
        (input)="input()" />
    <mat-autocomplete
        autoActiveFirstOption
        #autocomplete="matAutocomplete"
        [displayWith]="config().labelDisplayFn.bind(this)"
        (optionSelected)="onOptionSelected($event)">
        @for (option of options; track option) {
            <mat-option [value]="option">
                <div class="leading-tight">
                    @if (config().topLabelDisplayFn; as topLabelDisplayFn) {
                        <div class="text-xs">{{ topLabelDisplayFn(option) }}</div>
                    }
                    <div>{{ config().labelDisplayFn(option) }}</div>
                </div>
            </mat-option>
        }
    </mat-autocomplete>
    <div matSuffix class="flex gap-2">
        @if (!config().shouldHideDataSelectDialogButton && !!config().dataSelectionDialogConfig && !isLoading && !isDisabled) {
            <button type="button" mat-icon-button (click)="openDataSelectionDialog($event)">
                <mat-icon>search</mat-icon>
            </button>
        }
        @if (isLoading) {
            <div class="grid h-[40px] w-[40px] place-items-center">
                <mat-spinner diameter="22" />
            </div>
        }
    </div>
</mat-form-field>
